import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateScenarioSafe } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const usePatchScenarioSafe = () => {
  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: updateScenarioSafe, isPending } = useAppMutation([QueryKey.PATCH_SCENARIO_SAFE], {
    mutationFn: ({
      data,
      scenarioId,
      id,
    }: {
      data: CreateScenarioSafe;
      id: string;
      scenarioId: string;
    }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'safe', id],
        },
        {
          body: data,
        },
      ),
    onSuccess: () => {
      invalidateCalculationQueries();
    },
  });
  return { updateScenarioSafe, isPending };
};
